import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/redux/store/store';
import { getCompanyRules } from '../api/General/Company';

interface CurrencyInfo {
  code: string;
  symbol: string;
  format: (amount: number | string, decimals?: number) => string;
}

export function useCurrency(): CurrencyInfo {
  const companyRulesCurrency = useSelector(
    (state: RootState) => state.user.company?.companyRules?.currency
  );
  const companyId = useSelector(
    (state: RootState) => state.user.company?.id
  );

  const [fetched, setFetched] = useState<{ currencyCode?: string; currencySymbol?: string } | null>(null);

  // If currency is not in Redux state, fetch from API
  useEffect(() => {
    if (!companyRulesCurrency && companyId && !fetched) {
      getCompanyRules(companyId)
        .then((result) => {
          if (result.errors.length === 0 && result.payload) {
            setFetched({
              currencyCode: (result.payload as any).currency?.currencyCode,
              currencySymbol: (result.payload as any).currency?.currencySymbol,
            });
          }
        })
        .catch(() => {});
    }
  }, [companyRulesCurrency, companyId, fetched]);

  const currency = companyRulesCurrency || fetched;
  const code = currency?.currencyCode || '';
  const symbol = currency?.currencySymbol || '';

  const format = (amount: number | string, decimals = 2): string => {
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(num)) return `${symbol || code} 0.${'0'.repeat(decimals)}`;
    const formatted = num.toFixed(decimals);
    return symbol ? `${symbol} ${formatted}` : code ? `${code} ${formatted}` : formatted;
  };

  return { code, symbol, format };
}
